import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MeusDadosForm from './components/MeusDadosForm'
import { decrypted } from '../../util/CryptoUtil'
import { getAddress } from '../../serviceAPI/getAddress'
import { getContact } from '../../serviceAPI/getContact'
import { postUpdatePerson } from '../../serviceAPI/postUpdatePerson'
import { postUploadPhotoProfile } from '../../serviceAPI/fotoPerfil/postUploadPhotoProfile'
import { getPhotoProfile } from '../../serviceAPI/fotoPerfil/getPhotoProfile'

function MeusDados() {
    const dispatch = useDispatch()

    const userEncrypt = localStorage.getItem(process.env.REACT_APP_USER)
    const userDecrypt = decrypted(userEncrypt)
    const user = JSON.parse(userDecrypt)

    const endereco = useSelector(state => state.endereco)
    const contato = useSelector(state => state.contato)
    const fotoPerfil = useSelector(state => state.fotoPerfil)

    async function submitUpdate(first_name, last_name) {
        await postUpdatePerson(first_name, last_name, endereco, contato, dispatch);
    }

    async function submitPhoto(file) {
        await postUploadPhotoProfile(file, dispatch);
    }

    React.useEffect(() => {
        getAddress(dispatch)
        getContact(dispatch)
        getPhotoProfile(dispatch)
    }, [dispatch]);

    return (
        <div>
            <MeusDadosForm
                user={user}
                onSubmit={submitUpdate}
                submitPhoto={submitPhoto}
                uriFotoPerfil={fotoPerfil.uri}
            />
        </div>
    )
}

export default MeusDados